import { Row, intlShape, withIntl } from "lcm-iot-commons";

type Props = {
  itemSerialNumber: string;
  itemSubAddress: number;
  intl: intlShape;
};

export function FieldGatewayGenericModbusSerialNumberSubAddressItem({
  itemSerialNumber,
  itemSubAddress,
  intl,
}: Props) {
  const { t } = intl;
  return (
    <Row>
      <div className="col-lg-3">
        {/* @ts-expect-error TS(2349) FIXME: This expression is not callable. */}
        <b>{t`field_gateway.modbus.config.item.serial_number_subaddress`}</b>
      </div>
      <div className="col-lg-6">{`${itemSerialNumber}, ${itemSubAddress}`}</div>
    </Row>
  );
}

export default withIntl(FieldGatewayGenericModbusSerialNumberSubAddressItem);
